import React from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { MapPin, CheckCircle2 } from "lucide-react";
import {
  SA_PRIMARY,
  SA_SECONDARY,
  saCardBg,
  saCardBorder,
  saReadableText,
  saGradientLine,
} from "./saSectionTokens";
import { EVENT_LOCATION } from "../../constants";

const riyadhPoints = [
  "The capital and command centre for Vision 2030 — home to government ministries, municipalities and national infrastructure authorities",
  "A thriving hub for giga projects including NEOM, New Murabba, Qiddiya, Diriyah, Red Sea Global and ROSHN",
  "Major urban transformation through Riyadh Metro, King Salman Park and Riyadh Municipality smart city initiatives",
  "One of the world's largest concentrations of mega-project investment and digital infrastructure development",
  "Proven destination for the Kingdom Digital Twin conference — returning for its 5th annual edition",
  "8 Saudi cities ranked in the IMD Smart City Index 2026, reflecting the Kingdom's rapid digital urban transformation",
];

function SARiyadhSection() {
  const size =
    document.body.clientWidth >= 928 || document.documentElement.clientWidth >= 928;

  return (
    <section className="section py-5" style={{ background: "transparent", position: "relative", zIndex: 1 }}>
      <Container>
        <Row className="justify-content-center mb-4">
          <Col lg={10} className="text-center text-lg-left">
            <h2
              className="mb-3"
              style={{
                fontSize: size ? "2.25rem" : "1.75rem",
                fontWeight: 700,
                letterSpacing: "0.06em",
                textTransform: "uppercase",
                color: SA_SECONDARY,
                ...saReadableText,
              }}
            >
              Why Riyadh?
            </h2>
            <div
              className="mx-auto ml-lg-0 mr-lg-0"
              style={{
                width: "100px",
                height: "4px",
                borderRadius: "2px",
                marginBottom: size ? "2rem" : "1.25rem",
                ...saGradientLine,
              }}
            />
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col lg={10}>
            <Card
              style={{
                background: saCardBg,
                backdropFilter: "blur(12px)",
                border: saCardBorder,
                borderRadius: "20px",
                padding: size ? "2rem" : "1.5rem",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div className="d-flex align-items-start mb-4">
                <div
                  style={{
                    width: size ? 52 : 46,
                    height: size ? 52 : 46,
                    minWidth: size ? 52 : 46,
                    borderRadius: "14px",
                    background: `linear-gradient(145deg, ${SA_PRIMARY}33, ${SA_SECONDARY}22)`,
                    border: `2px solid ${SA_PRIMARY}55`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <MapPin size={size ? 26 : 22} strokeWidth={2} style={{ color: SA_PRIMARY }} />
                </div>
                <div className="ml-3">
                  <p
                    className="mb-0"
                    style={{
                      fontSize: size ? "1.18rem" : "1.05rem",
                      lineHeight: 1.75,
                      fontWeight: 600,
                      ...saReadableText,
                    }}
                  >
                    The event takes place in {EVENT_LOCATION} — the heart of the Kingdom&apos;s
                    Vision 2030 transformation and one of the world&apos;s most ambitious centres
                    for smart cities, giga projects and digital infrastructure.
                  </p>
                </div>
              </div>
              <p
                className="mb-3"
                style={{
                  fontSize: size ? "1.05rem" : "0.98rem",
                  fontWeight: 600,
                  color: SA_SECONDARY,
                  ...saReadableText,
                }}
              >
                Riyadh offers:
              </p>
              <ul className="list-unstyled mb-0">
                {riyadhPoints.map((line, i) => (
                  <li key={i} className="d-flex mb-2" style={{ ...saReadableText }}>
                    <CheckCircle2
                      className="flex-shrink-0 mt-1"
                      size={18}
                      style={{ color: SA_PRIMARY, marginRight: "0.65rem" }}
                      strokeWidth={2.2}
                    />
                    <span style={{ fontSize: size ? "1.02rem" : "0.94rem", lineHeight: 1.65 }}>
                      {line}
                    </span>
                  </li>
                ))}
              </ul>
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  ...saGradientLine,
                  opacity: 0.85,
                }}
              />
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SARiyadhSection;
